module.exports = __webpack_public_path__ + "static/media/dna.43a485b5.svg";